var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-button", { staticClass: "clear", on: { click: _vm.clickClear } }, [
        _vm._v("クリア")
      ]),
      _c(
        "el-button",
        {
          staticClass: "register",
          attrs: { type: "primary" },
          on: { click: _vm.clickRegister }
        },
        [_vm._v("登録")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }